import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { EMPTY, from, switchMap } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  return from(authService.getValidAccessToken()).pipe(
    switchMap(token => {
      if (!token) {
        const isOAuthCallback = new URL(window.location.href).searchParams.has('code');
        if (isOAuthCallback) {
          return EMPTY;
        }

        authService.logout();
        return EMPTY;
      }

      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });

      return next(req);
    }),
  );
};
